import { render, staticRenderFns } from "./RecordManageDetail.vue?vue&type=template&id=6d414106&scoped=true"
import script from "./RecordManageDetail.vue?vue&type=script&lang=js"
export * from "./RecordManageDetail.vue?vue&type=script&lang=js"
import style0 from "./RecordManageDetail.vue?vue&type=style&index=0&id=6d414106&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d414106",
  null
  
)

export default component.exports